<template>
  <div class="example-preview table-responsive overflow-auto mt-3">
    <table class="table text-left table-hover table-bordered table-vertical-center b-table">
      <thead>
      <tr style="background-color: #472F92; color: white">
        <th style="width: 40px">STT</th>
        <th style="max-width: 180px">Phòng ban</th>
        <th>Nhân sự</th>
        <th>Người lead</th>
        <th style="width: 120px">Trạng thái</th>
        <th class="text-center" style="width:150px">Hành động</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="dataKra?.length > 0">
        <tr v-for="(item, index) in dataKra" :key="item.id">
          <td class="text-center">{{ getIndex(page, index, 20) }}</td>
          <td>
            <el-tooltip class="item" effect="dark" placement="top" :content="item.department">
              <span class="line-clamp-1">{{ item?.department ?? '' }}</span>
            </el-tooltip>
          </td>
          <td>
            <span :class="item.colorType">{{ item?.human }}</span>
          </td>
          <td>{{ item?.leader }}</td>
          <td>
            <div
                :class="item.bgStatus"
                style="padding: 4px 8px; border-radius: 4px; text-align: center; width: 100%"
            >
              {{ item?.status }}
            </div>
          </td>
          <td class="text-center">
            <el-tooltip class="item" effect="dark" placement="top" content="Duyệt">
              <button class="btn btn-outline-success p-0" type="button" @click="showKraByUser(item)">
                <i class="el-icon-check p-2"></i>
              </button>
            </el-tooltip>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="7" class="text-center">Chưa có dữ liệu</td>
        </tr>
      </template>
      </tbody>
    </table>
    <el-dialog
        class="responsive" v-if="isApprove" width="60%"
        :visible.sync="isApprove" append-to-body
        title="Duyệt KRA" @close="closeDialog"
    >
      <hr style="margin-top: -20px; margin-bottom: 25px; border: 1px solid lightgray"/>
      <TableKraByUser v-loading="loading" :kra-by-user="kraByUser" @closeDialog="closeDialog" @getListKraByUser="getListKra"/>
    </el-dialog>
  </div>
</template>

<script>
import TableKraByUser from "@/view/pages/manage-kras/component/TableKraByUser.vue";
import { GET_LIST_KRA_BY_USER } from "@/core/services/store/okrs/okr.module";
import { KraByUserModel } from "@/view/pages/manage-kras/model/KraModel";
import moment from "moment-timezone";

export default {
  name: 'TableKra',
  components: { TableKraByUser },
  props: {
    dataKra: {
      type: Array,
      required: true,
      default: () => []
    },
    page: {
      type: Number,
      required: true,
      default: 1
    },
    filters: {
      type: Object,
      default: () => {
      }
    }
  },

  data() {
    return {
      isApprove: false,
      kraByUser: [],
      loading: false
    }
  },
  methods: {
    getIndex(page, index, limit) {
      return this.getIndexPaginate(page, index, limit)
    },

    closeDialog() {
      this.kraByUser = []
      this.loading = false
      this.isApprove = false
    },

    getListKra() {
      this.$emit('getListKra')
    },

    showKraByUser(user) {
      this.loading = true
      this.isApprove = true
      const payload = {
        user_id: user.userId,
        month: this.filters.month ?? moment(new Date()).format("M"),
        year: this.filters.year ?? moment(new Date()).format("YYYY")
      }
      this.$store.dispatch(GET_LIST_KRA_BY_USER, payload).then(res => {
        if (!res.error) {
          this.kraByUser = res.data.map(item => new KraByUserModel(item))
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.loading = false
      })
    },

    getListOkr() {
      this.$emit('getListKra');
    }
  }
}
</script>

<style>
.bg-yellow {
  background: #D26D09 !important;
  color: white !important;
}

.bg-green {
  background: green !important;
  color: white !important;
}

#success-okr .el-input__inner {
  color: green;
}

#fail-okr .el-input__inner {
  color: red;
}
</style>
